const AudioPlayer = () => {
  return null;
};

export default AudioPlayer;
